const footerLinks = [
  {
    title: '热门平台',
    items: ['红桃视频', '樱桃视频', '茄子视频', '糖心视频'],
  },
  {
    title: '内容导航',
    items: ['电视剧全集', '电影大全', '热门专题', '最新更新'],
  },
  {
    title: '帮助中心',
    items: ['常见问题', '使用指南', '联系我们', '意见反馈'],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="text-xl font-heading font-bold text-primary-400 block mb-4">
              玫瑰视频
            </span>
            <p className="text-sm leading-relaxed text-background-50/50">
              玫瑰视频汇聚红桃视频、樱桃视频、茄子视频、糖心视频等平台高清资源，免费在线观看不缓冲，最新电视剧全集和电影大全一网打尽，追剧观影首选平台。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-primary-500/30 transition-colors cursor-pointer">
                <i className="ri-live-line text-base"></i>
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li key={item}>
                    <span className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
              <span className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer">
                用户协议
              </span>
              <span className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer">
                隐私政策
              </span>
              <span className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer">
                版权声明
              </span>
            </div>
            <p className="text-xs text-background-50/30">
              &copy; 2026 玫瑰视频 版权所有
            </p>
          </div>

          <div className="mt-6 pt-4 border-t border-background-50/5">
            <h4 className="text-xs font-semibold text-background-50/30 mb-2">
              合作伙伴
            </h4>
            <p className="text-xs text-background-50/20">
              诚邀优质影视平台合作，共创高清观影生态
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}